export default "__VITE_ASSET__18804cc0__"